import { MenuButtonProps } from './types';

export const MenuButton = ({ children, classNames = '', onItemClick, ...props }: MenuButtonProps) => {
    return (
        <button {...props} className={`${classNames}`} onClick={onItemClick}>
            {children}
        </button>
    );
};
